import { vTooltip } from "@sieg-ad/componentes-vue";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', vTooltip);
});
